module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"addSubject":"Add subject"},"fr":{"addSubject":"Ajout d\u0027un sujet"}}')
  delete Component.options._Ctor
}
